import { render, staticRenderFns } from "./VeritasChristmasVideo2020.vue?vue&type=template&id=4c7cedeb&scoped=true"
import script from "./VeritasChristmasVideo2020.vue?vue&type=script&lang=js"
export * from "./VeritasChristmasVideo2020.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7cedeb",
  null
  
)

export default component.exports